import { render, staticRenderFns } from "./post-add-stickers.vue?vue&type=template&id=619992e9"
import script from "./post-add-stickers.vue?vue&type=script&lang=js"
export * from "./post-add-stickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports